export default __webpack_public_path__ + "static/media/hover-x.eed1a04e.svg";